import { active_app_flavor } from ":public-dynamic/whitelabel";

export function getAppFlavor() {
  return Promise.resolve(active_app_flavor);
}
